import React from 'react'

type SlideOutFooterProps = {
  children: React.ReactNode
}

export function SlideOutFooter({ children }: SlideOutFooterProps) {
  return <footer className='flex justify-end fixed p-6 bottom-0 right-0 w-[575px] bg-white'>{children}</footer>
}
